<template>
  <span :class="['label text-danger']">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: ['errors'],
};
</script>
